import { Alert, Space } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetchZervantSubscription } from '@features/zervant-subscription/hooks/useFetchZervantSubscription'

import { formatDate } from '../../../../../../../utils'

export const ZervantFormerSubscriberBox = (): ReactElement | null => {
  const { t, i18n } = useTranslation()
  const { zervantSubscription } = useFetchZervantSubscription()

  if (zervantSubscription?.plan?.id !== 'fr_free' || !zervantSubscription.lastPremiumEndDate) {
    return null
  }

  const endDate = formatDate(new Date(zervantSubscription.lastPremiumEndDate), undefined, i18n.language) ?? ''

  return (
    <>
      <Space size="s16" />
      <Alert variant="info">
        {t('organization_subscription.former_zervant_subscriber.description', { date: endDate })}{' '}
        <a
          href={t('organization_subscription.former_zervant_subscriber.support_url')}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('organization_subscription.former_zervant_subscriber.support_link')}
        </a>
      </Alert>
    </>
  )
}
